// extracted by mini-css-extract-plugin
export default {"switch":"kblrIn0Y_t6CM6uzTMOM","checked":"BFZpFI7YU9g74BWxiuvx"};